import {useTranslation} from "react-i18next";
import React, {useEffect, useRef} from "react";
import StandardModal, { ModalSize} from "../../Fundamentals/Modal/StandardModal";
import {useDispatch, useSelector} from "react-redux";
import Modals from "../../../Constants/modals";
import {CreateSaasCustomerForm} from "../EditCustomer/CreateSaasCustomerForm";
import {CreateVossCustomerForm} from "../EditCustomer/CreateVossCustomerForm";
import {EditVbCustomerForm} from "../EditCustomer/EditVbCustomerForm";
import {EditVbAndVossCustomerForm} from "../EditCustomer/EditVbAndVossCustomerForm";
import {EditVossCustomerForm} from "../EditCustomer/EditVossCustomerForm";
import useModal from "../../../Hooks/useModal";
import {bindActionCreators} from "redux";
import formActionsImp from "../../../Actions/formActions";
import customerActionsImp from "../../../Actions/customerActions";

export default function CustomerModal ({}) {
    const dispatch = useDispatch();
    const { t} = useTranslation();
    const activeForm = useSelector((state) => state.CommonReducer.currentlyActiveModal);
    const dataLoading = useSelector((state) => state.CommonReducer.dataLoading.editCustomer || state.CommonReducer.dataLoading.saveCustomer || state.CommonReducer.dataLoading.customerConnections || state.CommonReducer.dataLoading.targetGroups);
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms.customerFormData);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const { closeModal } = useModal();

    useEffect(() => {
        
        return () => {
            formActions.cancelFormEditing('customerFormData');
        }
    }, []);
    
    const submit = () => {
        if (activeForm === Modals.CreateCustomer || activeForm === Modals.CreateSaasCustomer) {
            return () => customerActions.createCustomer(form, closeModal)
        } else {
            return () => customerActions.saveCustomer(form, closeModal)
        }
    }

    function handleSubmit() {
        formActions.submitForm(form, submit());
    }

    return <StandardModal
        title={`${t(`customermodal.${activeForm}`)}`}
        isLoading={dataLoading}
        size={activeForm === Modals.CreateCustomer || activeForm === Modals.CreateSaasCustomer ? ModalSize.LARGE : ModalSize.X_LARGE}
        onSubmit={handleSubmit}
    >
        {activeForm === Modals.EditVbCustomer && <EditVbCustomerForm />}
        {activeForm === Modals.EditVossAndVbCustomer && <EditVbAndVossCustomerForm />}
        {activeForm === Modals.EditVossCustomer && <EditVossCustomerForm />}
        {activeForm === Modals.CreateCustomer && <CreateVossCustomerForm />}
        {activeForm === Modals.CreateSaasCustomer && <CreateSaasCustomerForm /> }
    </StandardModal>
}
